import React, {useEffect, useRef} from 'react'
import styles from './UIGameFeedScrollContainer.module.scss'

export function UIGameFeedScrollContainer({
    children,
    scrollToChildIndex,
}: {
    children: React.ReactNode
    scrollToChildIndex?: number | null
}) {
    const isMouseOverRef = useRef<boolean>(false)
    const containerRef = useRef<HTMLDivElement>(null)

    const scrollToChild = (index: number, behavior: ScrollBehavior = 'smooth') => {
        if(!containerRef.current) return

        const element = containerRef.current.children[index]
        if(element == null) return
        window.requestAnimationFrame(() => {
            element.scrollIntoView({block: 'center', behavior: behavior})
        })
    }

    useEffect(() => {
        if(!containerRef.current) return
        if(isMouseOverRef.current) return

        if(typeof scrollToChildIndex === 'number') scrollToChild(scrollToChildIndex)
        else containerRef.current.scrollTop = containerRef.current.scrollHeight
    }, [children, scrollToChildIndex])

    return (
        <div
            className={styles.container}
            onMouseEnter={() => isMouseOverRef.current = true}
            onMouseLeave={() => isMouseOverRef.current = false}
            ref={containerRef}
        >
            {children}
        </div>
    )
}
